module.exports = __webpack_public_path__ + "static/img/Aions_Mar_10.1ecc65c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Aions_Mar/Aions_Mar_10.png
// module id = QRK6
// module chunks = 19